import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition} from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { Layer } from "../../models/layer.model";
import { Thematic } from "../../models/thematic.model";
import { UrlParamsService } from "../../services/utils/url-params.service";
import * as $ from 'jquery';
import { interaction } from 'openlayers';
import {ModalService} from '../../services/modal/modal.service';



window["$"] = $;
window["jQuery"] = $;
@Component({
    selector: 'app-gisweb',
    templateUrl: './gisweb.component.html',
    styleUrls: ['./gisweb.component.css'],
    animations: [
        trigger('slideInOutTools', [
            state('out', style({ left: -500, opacity: 0.0, zIndex: 8 })),
            state('in', style({ left: 0, opacity: 1.0, zIndex: 2 })),
            transition('in => out', animate('400ms ease-out')),
            transition('out => in', animate('400ms ease-in'))
        ]), trigger('slideInOutLayer', [
            state('out', style({ right: -500, opacity: 0.0, zIndex: 8 })),
            state('in', style({ right: 0, opacity: 1.0, zIndex: 8 })),
            transition('in => out', animate('400ms ease-out')),
            transition('out => in', animate('400ms ease-in'))
        ]),
      ]
})

export class GiswebComponent implements OnInit {


    /*- Variables privades -*/
    private layerToCheck = [];
    private thematicToRemove = {};
    private thematicToAdd = {};
    /* Selectors HTML */
    private mapDiv: HTMLElement;
    private headerDiv: HTMLElement;
    private toolToAdd: Event;

    private interactionToAdd: Event;
    private featureInfo: any;
    private escalaActual: any;
    private interactionToRemove: interaction.Interaction;
    private markerMap = {};
    private tipusHeader = "default";
    private hasDownloadPDF: any;
    private printPreviewMap: any;
    private printMapInput: any;
    /*- Variables publiques -*/
    layerMenuState: string = 'in';
    toolsMenuState: string = 'out';
    selectedLegend: any;
    private showPanel = {
        draw: false,
        measureLine: false,
        measureSurf: false,
        print: false,
        identify: false,
        legend: false,
    };
    public isLoginModalVisible: boolean = false;
    /**/
    constructor(private translate: TranslateService, private urlParamsService: UrlParamsService, private modalService: ModalService) {
        console.debug(" >>> GiswebComponent: constructor");
        translate.addLangs(['ca', 'es', 'en']);
        translate.setDefaultLang('ca');
        translate.use('ca');
    }
    ngOnInit() {
        console.debug(" >>> GiswebComponent: ngOnInit");


        let params = window.location.search.substring(1).split("&");
        params.forEach(value => {
            let pair = value.split(/=(.+)?/);
            this.urlParamsService.setParam(pair[0], pair[1]);
        });

    
    }

    public changeLang(lang: string) {
        console.debug(" >>> GiswebComponent: changeLang");
        this.translate.use(lang);
    }
    public ngAfterViewInit() {
        console.debug(" >>> GiswebComponent: ngAfterViewInit");
        // establir l'alçada dels panells i del mapa
        //let height = window.innerHeight - 55 + "px";
        //$(".app-map-container").css("height", height);
        if (this.checkMobile() || window.innerWidth < 768) {
            this.layerMenuState = 'out';
            this.toolsMenuState = "out";//amaguem l'altre
        } else {
            this.layerMenuState = 'in';
            this.toolsMenuState = "out";//amaguem l'altre
        }
    }

    public loginModalVisibilityHandler(event: boolean): void {
        this.isLoginModalVisible = event;
    }

    /**
       * Es crida quan es fa una acció al header.
       * Mostra la informació associada al tool passat per paràmetre
       * @param {String} tool.
       */
    private toolCheckedHandler(event: String): void {
        console.debug(" >>> GiswebComponent: toolCheckedHandler");
        if (event === "layer") {
            switch (this.layerMenuState) {
                case 'in':
                    this.layerMenuState = 'out';
                    break;
                case 'out':
                    this.layerMenuState = 'in';
                    this.toolsMenuState = 'out';
                    this.showPanel.identify = false;
            }
        }
        else if (event === "tools") {
            switch (this.toolsMenuState) {
                case 'in':
                    this.toolsMenuState = 'out';
                    break;
                case 'out':
                    this.toolsMenuState = 'in';
                    this.layerMenuState = 'out';
                    this.showPanel.identify = false;
            }
            this.showPanel.draw = false;
            this.showPanel.measureLine = false;
            this.showPanel.measureSurf = false;
            this.showPanel.print = false;
            this.showPanel.legend = false;
        }
    }

    private toggleLayer(event: Layer[]): void {
        console.debug(" >>> GiswebComponent: toggleLayer");
        this.layerToCheck = event;
    }

    private addThematicHandlerAC(event: Thematic): void {
        console.debug(" >>> GiswebComponent: addThematicHandlerAC");
        this.thematicToAdd = event;
    }
    private removeThematicHandlerAC(event: Thematic): void {
        console.debug(" >>> GiswebComponent: removeThematicHandlerAC");
        this.thematicToRemove = event;
    }

    private addInteractionHandler(event) {
        console.log(">>> GiswebComponent: addInteractionHandler");
        this.interactionToAdd = event;
    }
    private removeInteractionHandler(event) {
        console.log(">>> GiswebComponent: removeInteractionHandler");
        // Hey map: remove this interaction.
        this.interactionToRemove = event.interaction;
        if (event.closePanel) {
            // Close any tool panel
            this.showPanel.measureLine = false;
            this.showPanel.measureSurf = false;
            this.showPanel.draw = false;
            this.showPanel.print = false;
            this.showPanel.legend = false;
            this.toolsMenuState = "in";
            if (this.checkMobile() || window.innerWidth < 768) {
                this.toolsMenuState = "out";
            }
        }


    }
    private addLayerToolHandler(event) {
        console.log(">>> GiswebComponent: addLayerToolHandler");
        this.toolToAdd = event;
    }

    private checkMobile(): boolean {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
        return isMobile;
    }

    private activateToolHandler(eventIdInteraction: string) {
        console.debug(">>> GiswebComponent: activateToolHandler", eventIdInteraction);

        //Hide any tool.
        this.showPanel.measureLine = false;
        this.showPanel.measureSurf = false;
        this.showPanel.draw = false;
        this.showPanel.print = false;
        this.showPanel.legend = false;


        //It's mobile? need to check it, for header issues.
        if (this.checkMobile() || window.innerWidth < 768) {
            this.tipusHeader = eventIdInteraction;
            this.toolsMenuState = "out";
        } else {
            this.toolsMenuState = "in";
            this.tipusHeader = "default";
        }

        //Measure Line tool
        if (typeof (eventIdInteraction) !== "undefined" && eventIdInteraction === "olMeasureDistance") {
            this.showPanel.measureLine = true;
        }

        //Measure Surface tool
        if (typeof (eventIdInteraction) !== "undefined" && eventIdInteraction === "olMeasureSurface") {
            this.showPanel.measureSurf = true;
        }

        //Draw tool
        if (typeof (eventIdInteraction) !== "undefined" && eventIdInteraction === "olDrawTool") {
            this.showPanel.draw = true;
        }

        //Draw tool
        if (typeof (eventIdInteraction) !== "undefined" && eventIdInteraction === "olPrintTool") {
            this.showPanel.print = true;
        }

        //Legend tool
        if (typeof (eventIdInteraction) !== "undefined" && eventIdInteraction === "legend") {
            this.showPanel.legend = true;
        }
        //Close right panel.
        //this.toolCheckedHandler("tools");
    }

    private closeToolsHandler(eventId: string) {
        console.log(">>> GiswebComponent: closeToolsHandler");
        this.showPanel.measureLine = false;
        this.showPanel.measureSurf = false;
        this.showPanel.draw = false;
        this.showPanel.print = false;
        this.showPanel.legend = false;
        this.tipusHeader = "default";
        if (eventId === "layer") {
            this.layerMenuState = "out";//amaguem el panell de capes
        }
        else if (eventId === "tools") {
            this.toolsMenuState = "out";//amaguem el panell de eines
        }
        else if (eventId == "identify") {
            this.showPanel.identify = false;
        }
        else if (eventId !== "") {
            this.removeInteractionHandler({ closePanel: true, interaction: eventId });
        }
    }

    private createPreviewMapHandler(event) {
        this.printPreviewMap = event;
    }
    private doPrintMapHandler(event) {
        this.printMapInput = event;
    }

    private openFeatureInfoHandler(event) {
        this.featureInfo = event;
        this.showPanel.identify = true;
        this.toolsMenuState = 'out';
        this.layerMenuState = 'out';
    }

    private getActualScale(event) {
       this.escalaActual = event;
    }


    private downloadCompletedHandler(event: String) {
        this.hasDownloadPDF = "";
        if (event.indexOf("print") >= 0) {
            this.hasDownloadPDF = event;
        }
    }

    selectedCandidateHandler(event) {
        this.markerMap = event;
    }

    legendSelectedHandler(event){
        console.log(event);
        this.selectedLegend = event;
        this.activateToolHandler("legend");
    }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/gisweb/gisweb.component.ts